export class BatchAssignments {
  static ASSIGN = 'ASSIGN'

  static UNASSIGN = 'UNASSIGN'
}
